import React from "react";

export function NoTemplate() {
    return (
        <li
            className={
                "px-20 pt-16 pb-36 text-sx bg-secondary-blue-lightest rounded-12 text-secondary-gray-dark"
            }
        >
            <p className={"font-semibold"}>Ingen skabelon tilgængelig</p>
        </li>
    );
}
